import { Box, Card, Paper, SvgIcon } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import Tooltip from '@mui/material/Tooltip';
import MDTypography from 'components/MDTypography';
import { useNavigate } from 'react-router-dom';
import { useFieldCharacterEditing } from '@mui/x-date-pickers/internals/hooks/useField/useFieldCharacterEditing';

export const UserCard = props => {
  const navigate = useNavigate();

  const getStyle = value => {
    let style = {
      overflowWrap: 'anywhere',
      textAlign: 'end',
      fontWeight: 'bold',
    };
    if (value >= 85) {
      style.color = '#00A551';
    } else if (value <= 84 && value >= 71) {
      style.color = '#FCB400';
    } else if (value <= 70) {
      style.color = '#BE1E2D';
    } else if (value === 0) {
      style.color = '#4e4e4e';
    }
    return style;
  };

  const handleUserClick = () => {
    navigate(`/manage-users/${props.id}`);
  };

  const AvatarIcon = props.role === 's' ? AdminPanelSettingsIcon : AccountCircleIcon;

  return (
    <Card
      onClick={handleUserClick}
      sx={{
        // my: 1.5,
        width: {
          xs: '100%',
          sm: '325px',
        },
        maxWidth: '100%',
        '&:hover': {
          cursor: 'pointer',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          transform: 'translateY(-2px)',
          transition: 'all 0.2s ease-in-out',
        },
        transition: 'all 0.2s ease-in-out',
      }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        ml={1}
        mr={1.25}
        my={-0.5}
        sx={{
          padding: '12px 0px 4px 0px',
        }}>
        <Box className="container">
          <Box
            className="topContainer"
            sx={{
              display: 'flex',
              width: '100%',
              maxWidth: '19.5rem',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
              <Paper
                className="sensorStatusIcon"
                color={'white'}
                elevation={1}
                style={{
                  // background: `linear-gradient(160deg, ${StatusColor[status][0]}, ${StatusColor[status][1]}`,
                  background: props.role === 's' ? 'black' : 'blue',
                }}
                sx={{
                  padding: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '3rem',
                  height: '3rem',
                }}>
                <AvatarIcon
                  sx={{
                    color: '#fff',
                    scale: '2',
                    '&:hover': {
                      color: '#fffff',
                    },
                  }}
                />
              </Paper>
              <MDTypography
                fontSize={16}
                sx={{
                  overflowWrap: 'anywhere',
                  marginLeft: '1rem',
                  fontWeight: 'bold',
                  color: '#000',
                }}>
                {props.username}
              </MDTypography>
            </Box>
          </Box>
          <Box sx={{ marginTop: '.5rem', width: '100%', maxWidth: '19rem' }}>
            <Tooltip
              title={
                <div style={{ textAlign: 'left' }}>
                  Buildings: {props.buildingNames?.join(', ') || 'No permissions'}
                  <br />
                </div>
              }>
              <MDTypography
                fontSize={14}
                sx={{
                  fontWeight: 'regular',
                  color: '#000',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  marginLeft: '',
                }}>
                <>
                  <div>
                    <strong>Role:</strong> {props.roleDisplay || props.role}
                  </div>
                  <div>
                    <strong>Name: </strong>
                    {props.fullName || `${props.firstName || ''} ${props.lastName || 'No name listed'}`}
                  </div>
                  <div>
                    <strong>Phone:</strong> {props.phone || 'No phone'}
                  </div>
                  <div>
                    {' '}
                    <strong>Email:</strong>
                    {props.email || 'No email'}
                  </div>
                  {props.role !== 's' && (
                    <div>
                      <strong>Buildings</strong>({props.buildingNames?.length || 0}):{' '}
                      {props.buildingNames?.length > 0
                        ? props.buildingNames.slice(0, 2).join(', ') +
                          (props.buildingNames.length > 2 ? `, +${props.buildingNames.length - 2} more` : '')
                        : 'No permissions'}
                    </div>
                  )}
                  {props.role === 'd' && <div>Customers: {props.customerCount || 0}</div>}
                </>
              </MDTypography>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '7px',
        }}></Box>
    </Card>
  );
};

export default UserCard;
